module.exports.webhookEventTypes = {
    TRANSACTION_PENDING: 'TRANSACTION_PENDING',
    TRANSACTION_AUTHORIZED: 'TRANSACTION_AUTHORIZED',
    TRANSACTION_CAPTURED: 'TRANSACTION_CAPTURED',
    TRANSACTION_CREDITED: 'TRANSACTION_CREDITED',
    TRANSACTION_VOIDED: 'TRANSACTION_VOIDED',
    TRANSACTION_SETTLED: 'TRANSACTION_SETTLED',
    TRANSACTION_REFUNDED: 'TRANSACTION_REFUNDED',
    CARD_SAVED: 'CARD_SAVED',
    APM_SAVED: 'APM_SAVED',
    CARD_DATA_UPDATED: 'CARD_DATA_UPDATED',
    ECHECK_SAVED: 'ECHECK_SAVED',
    ACCOUNT_UPDATER_ACCOUNT_CLOSED: 'ACCOUNT_UPDATER_ACCOUNT_CLOSED',
    ACCOUNT_UPDATER_CONTACT_CARDHOLDER: 'ACCOUNT_UPDATER_CONTACT_CARDHOLDER',
    PAYOUT: 'PAYOUT',
    SPENDBACK: 'SPENDBACK',
    TRANSACTION: 'TRANSACTION',
    SUBSCRIPTION_DETAILS: 'SUBSCRIPTION_DETAILS',
    DECLINE_RECOVERY: 'DECLINE_RECOVERY'
};
